import React from 'react';
import {
    Form, Label, FormGroup, Card, Input, Button, CardBody,
    Modal, ModalHeader, ModalBody, ModalFooter, Progress,  FormText,
} from 'reactstrap';
import {appHelpers, store} from '../../_helpers';


import NotificationSystem from 'react-notification-system';
 import {connect} from "react-redux";
import {alertActions, commonActions, modalActions} from "../../_actions";
import {alertConstants, appConstants} from "../../_constants";
import {apiActions} from "../../_actions/api.actions";
import CheckIcon from 'react-icons/lib/md/info';

//Page content util
import PageLoading from "../utils/page.loading";
import PageError from "../utils/page.error";
 import SelectListComponent from "../utils/selectList";
import PageEmptyContent from "../utils/page.empty-content";
 import UserWorkflowTable from "./user-table";
//Icons
import AddIcon from 'react-icons/lib/md/library-add';
import UserIcon from 'react-icons/lib/md/verified-user';
import {commonService} from "../../_services";

const ViewContent = ({children}) => (
    <div className="view-content view-components">
        {children}
    </div>
);

class WorkflowUserViewContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            workFlow: null,
            workflowUsers: [],
            WorkflowActions: [],
            users: [],
            modal: false,
            workflowUserModal: false,
            workflowDeleteModal: false,
            modalClass: '',
            //  Workflow form
            WorkflowActionId : '',
            WorkflowActionUserName : '',
            WorkflowActionUserId : '',
            WorkflowActionUser : '',
            UserId: '',

            //page error
            contentError: false,  //Errors that affect content on the page
            componentError: false,  //Errors generated within the component
            componentErrorMessages: [],  //Errors generated within the component form
            error: false, //Error state mutable via Redux
            success: false, //Success message mutable via Redux

            //    Notification
            notification: {
                // title: 'Default Title',
                message: 'Default Message',
                level: 'success',
                position: 'tr',
                dismissible: true
            },
            // Pagination params
            pageSize: 10,
            currentPage: 1,
            totalRecordsCount: 0,
        };

        this._notificationSystem = null;
        this._lastNotificationAdded = null;
    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        const  queryString = window.location.href.split('/');
        this.fetchWorkFlow(queryString[queryString.length - 1]);

        const reduxState = store.getState();
        let { users } = reduxState;
        if(users){
            users.ResultList.map(item => item.Name = `${item.FirstName}  ${item.LastName}`);
            this.setState({users: users.ResultList })
        }else{
            this.fetchOrgUsers();
        }
    }

    componentWillReceiveProps = function (nextProps) {
        const {alert} = nextProps;
        const {modal} = nextProps;

        if (alert) {
            if (alert.type === alertConstants.SUCCESS) {
                this.setState({error: false, success: 'Operation successful'});
                this.resetForm();
            }
            else if (alert.type === alertConstants.CLEAR) {
                this.setState({success: false, error: false})

            } else {
                this.setState({success: false, error: alert.message})
            }
        }
        if (modal) {
            if (modal.type === appConstants.OPEN_MODAL) {
                this.setState({
                    modal: true,
                    modalClass: modal.modalClass
                });
            } else if (modal.type === appConstants.CLOSE_MODAL) {
                this.setState({
                    modal: false,
                    modalClass: modal.modalClass
                });
                this.resetForm();
            }
        }

    };

    handleChange = (event, attribute) => {
        let currState = this.state;
        currState[attribute] = event.target.value;
        let errorMessages = this.state.componentErrorMessages;
        errorMessages[attribute] = false;
        this.setState(currState);
        this.setState({componentErrorMessages: errorMessages});
    };

    handleSelectChange = (payload, attribute, stateAttribute) => {
        let currState = this.state;
        let errorMessages = this.state.componentErrorMessages;
        errorMessages[stateAttribute] = false;
        currState[stateAttribute] = (payload) ? payload[attribute] : ''; //Cater for setting up data and clearing data
        this.setState(currState);
    };

    validateInput = () => {
        let _errs_ = [];
        let formValid = true;
        if(this.state.UserId === ''){
            _errs_['UserId'] = 'Please select user';
            formValid = false;
        }

        if(this.state.WorkflowActionId === ''){
            _errs_['WorkflowActionId'] = 'Please select action type';
            formValid = false;
        }
        this.setState({componentErrorMessages: _errs_});
        return formValid;
    };
    notify = (message, level) => {
        let notification = this.state.notification;
        notification['message'] = message;
        notification['level'] = level;
        notification.onRemove = this.onRemove;
        this._lastNotificationAdded = this._notificationSystem.addNotification(notification);
    };

    onRemove = (notification) => {
        if (this._lastNotificationAdded && notification.uid === this._lastNotificationAdded.uid) {
            this._lastNotificationAdded = null;
        }
    };

    resetForm() {
        this.setState({
            componentError: false, componentErrorMessages: [], UserId: '', WorkflowActionId: '', WorkflowActionUserId: false, WorkflowActionUserName: false, WorkflowActionUser: ''
        });
        this.resetError();
    }

    handleSubmit  = (event) => {
        event.preventDefault();
        this.setState({isRequesting: true});
        this.resetError();
        if(this.validateInput()){
            this.processSubmit();
        }
    };

    resetError() {
        this.props.dispatch(modalActions.clear());
        this.props.dispatch(alertActions.clear());
    }

    processSubmit = () => {
        let { WorkflowActionId, UserId, WorkflowActionUserId, workFlow } = this.state;
        let payload = {
            WorkflowActionId, UserId, Id: WorkflowActionUserId
        };
        const {dispatch} = this.props;
        dispatch(apiActions.startRequest());
        commonService.createWorkflowUser(payload)
            .then((res) => {
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    this.toggle('workflowUserModal');
                    dispatch(apiActions.endRequest());
                    this.notify('User details saved successfully', appConstants.NOTIFY_SUCCESS);
                    this.fetchWorkflowUsers(1, workFlow.Id);
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    dispatch(apiActions.endRequest());
                }
            });
    };

    removeUser = () => {
        let { WorkflowActionUserId, workFlow } = this.state;
        const {dispatch} = this.props;
        dispatch(apiActions.startRequest());
        commonService.removeWorkflowUser(WorkflowActionUserId)
            .then((res) => {
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    this.toggle('workflowDeleteModal');
                    dispatch(apiActions.endRequest());
                    this.notify('User removed successfully', appConstants.NOTIFY_SUCCESS);
                    this.fetchWorkflowUsers(1, workFlow.Id);
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    dispatch(apiActions.endRequest());
                }
            });
    };

    fetchWorkFlow = (param) => {
        let { dispatch } = this.props;
        dispatch(apiActions.startFullPageRequest());
        let payload = {
            "From": 0,
            "PageSize": 1,
            "Parameter":{
                "Id": param,
                "IncludeWorkflowActions": true
            }
        };
        commonService.getWorkFlows(payload)
            .then((res) => {
                 if (res.status === appConstants.SUCCESS_RESPONSE) {
                    const workFlow = res.response.Results[0];
                    let WorkflowActions = (workFlow.WorkflowActions === null) ? [] : workFlow.WorkflowActions;
                    if(res.response.TotalCount === 0){
                        this.setState({contentError: 'Workflow does not exist'});
                        dispatch(apiActions.endRequest());
                    }else{
                        this.setState({workFlow, WorkflowActions});
                        this.initWorkflowUsers(workFlow.Id);
                    }
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                     this.setState({contentError: 'Unable to get Workflow details'});
                        dispatch(apiActions.endRequest());
                }
            });
     };

    initWorkflowUsers = (workflowId) => {
        let { dispatch } = this.props;
        let { pageSize } = this.state;
        dispatch(apiActions.startFullPageRequest());

        let payload = {
            "From": 0,
            "PageSize": pageSize,
            "Parameter":{
                "WorkflowId": workflowId
            }
        };
        commonService.getWorkFlowUsers(payload)
            .then((res) => {
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    const workflowUsers = res.response.Results;
                    this.setState({workflowUsers,  currentPage: 1, totalRecordsCount : res.response.TotalCount});
                    dispatch(apiActions.endRequest());
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                     this.setState({contentError: 'Unable to get Workflow users'});
                    dispatch(apiActions.endRequest());
                }
            });
     };
    fetchWorkflowUsers = (pageNumber) => {
        let { dispatch } = this.props;
        let { pageSize, workFlow } = this.state;
        let fromIndex;
        if(pageNumber === undefined){
            dispatch(apiActions.startFullPageRequest());
            fromIndex = 0;
            pageNumber = 1;
        }else{
            fromIndex = pageSize * (pageNumber - 1);
            dispatch(apiActions.startRequest());

        }
        let payload = {
            "From": fromIndex,
            "PageSize": pageSize,
            "Parameter":{
                "WorkflowId": workFlow.Id
            }
        };
        commonService.getWorkFlowUsers(payload)
            .then((res) => {
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    const workflowUsers = res.response.Results;
                    this.setState({workflowUsers,  currentPage: pageNumber, totalRecordsCount : res.response.TotalCount});
                    dispatch(apiActions.endRequest());
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    this.notify('Currently unable to get users.', appConstants.NOTIFY_ERROR);
                    dispatch(apiActions.endRequest());
                }
            });
     };

    fetchOrgUsers = () => {
        this.setState({contentError: false});
        const {dispatch} = this.props;
        const payload = { OrgId: appConstants.NCAA_ORG_ID  };
        // const payload = { };
        dispatch(commonActions.getUsersByOrganization(payload))
            .then(() => {
                let { users } = this.props;
                 users.ResultList.map(item => item.Name = `${item.FirstName}  ${item.LastName}`);
                this.setState({users: users.ResultList });
            }).catch(error => {
            let errorMessage = appHelpers.interpretErrorResponse(error);
            this.notify(errorMessage, appConstants.NOTIFY_ERROR);
            this.setState({contentError: errorMessage});
        });
    };

    passUserWorkflowDetails = (user) => {
        const {WorkflowActionId, UserId} = user;
        this.toggle('workflowUserModal');
        this.setState( { WorkflowActionId, UserId, WorkflowActionUserId: user.Id, WorkflowActionUserName: `${user.FirstName} ${user.LastName}` } );
    };
    passUserDeleteWorkflowDetails = (user) => {
        this.toggle('workflowDeleteModal');
        this.setState( { WorkflowActionUserId: user.Id, WorkflowActionUser: user} );
    };
    toggle = (modal) => {
        let currState = this.state;
        currState[modal] = !currState[modal];
        this.setState(currState);
        if(modal !== 'workflowUserEditModal'){
            this.resetForm();
        }
    };
    renderPageResponse() {
        if(this.state.error){
            return (<div className="alert alert-danger">{this.state.error}</div>);
        }
        else if(this.state.componentError){
            return (<div className="alert alert-danger">{this.state.componentError}</div>);
        }
        else if(this.state.success){
            return (<div className="alert alert-success">{this.state.success}</div>);
        }
    }

    render() {
        let modalResponse = this.renderPageResponse();
        const { requesting } = this.props;
        const { pageRequesting } = this.props;
        const { contentError, WorkflowActionUserId, WorkflowActionUserName, WorkflowActionUser, users, componentErrorMessages, workflowUsers, workFlow, pageSize, currentPage, totalRecordsCount, WorkflowActions } = this.state;
         let workflowUsersLength = workflowUsers.length;
        return (
            <div className="view">
                <ViewContent>
                    <Card className="mb-4">
                        {/*Progress bar for Pending API Request*/}
                        { ((pageRequesting || requesting) && !pageRequesting ) && <Progress animated striped color="success" value={100} className="mb-2"/> }

                        {/*Display loader when component content is dependent on Data from API*/}
                        { (!contentError && pageRequesting) &&
                            <PageLoading/>
                        }

                        {/*Display error when component fail to get Data from API*/}
                        { contentError &&
                             <PageError error={this.state.contentError }/>
                        }

                        {/*Display component content when Data is gotten from API*/}
                        { (!contentError && !pageRequesting) &&
                             <CardBody className="table-responsive">
                            <div className="row">
                                <h6 className="mb-4 col-md-8 text-uppercase pull-left">
                                    { (workFlow !== null) && workFlow.Name}
                                    <FormText color="muted">
                                        {
                                            (totalRecordsCount > 0) &&
                                            <div>
                                                <UserIcon size="18" color="#43a8df"/>&nbsp;
                                                <span>{ totalRecordsCount }&nbsp;
                                                    { (totalRecordsCount === 1) ? 'user assigned' : 'users assigned' }
                                                 </span>
                                            </div>
                                        }
                                    </FormText>
                                    </h6>
                                <div className="mb-4 col-md-4 text-right">
                                    <Button disabled={users.length === 0} className="btn-avi-secondary" onClick={(e) => this.toggle('workflowUserModal')}>
                                        <AddIcon color="#ffffff" size="18"/>&nbsp;Add New User
                                     </Button>{" "}
                                </div>
                            </div>
                                 {(!pageRequesting &&  workflowUsersLength > 0) &&
                                    <UserWorkflowTable data={ workflowUsers } deleteCallback={this.passUserDeleteWorkflowDetails} editCallback={this.passUserWorkflowDetails} totalRecordsCount={totalRecordsCount} currentPage={currentPage} pageSize={pageSize} pageDataCallback={this.fetchWorkflowUsers}/>
                                 }

                                 {(!pageRequesting && workflowUsersLength === 0) &&
                                    <PageEmptyContent message='No user attached to this workflow yet!'/>
                                 }

                            <Modal isOpen={this.state.workflowUserModal} toggle={() => this.toggle('workflowUserModal')} className={this.state.modalClass}>
                                <ModalHeader toggle={() => this.toggle('workflowUserModal')}>User Workflow</ModalHeader>
                                <Form onSubmit={this.handleSubmit}>
                                    <ModalBody>
                                        { modalResponse }
                                        {
                                            (!WorkflowActionUserId) &&
                                            <FormGroup className={"mb-4 " + (this.state.componentErrorMessages.UserId ? 'has-danger' : '')}>
                                                <Label>User</Label>
                                                <SelectListComponent data={users} placeholder={'Select user...'} valueKey='Id' textField='Name' selectValue={this.state.UserId} onValueChange={(payload) => this.handleSelectChange(payload, 'Id', 'UserId')} />
                                                { componentErrorMessages.UserId && <FormText color="danger"> {componentErrorMessages.UserId }</FormText> }
                                            </FormGroup>
                                        }
                                        {
                                            (WorkflowActionUserName) &&
                                            <FormGroup className={"mb-4 " + (this.state.componentErrorMessages.UserId ? 'has-danger' : '')}>
                                                <Label>User</Label>
                                                <Input type="text" placeholder="" disabled={true} value={WorkflowActionUserName} onChange={(event) => {}} />
                                            </FormGroup>
                                        }

                                        <FormGroup className={"mb-4 " + (this.state.componentErrorMessages.WorkflowActionId ? 'has-danger' : '')}>
                                            <Label for="countrySelect">Action </Label>
                                            <SelectListComponent data={WorkflowActions} placeholder={'Select action...'} valueKey='Id' textField='Name' selectValue={this.state.WorkflowActionId} onValueChange={(payload) => this.handleSelectChange(payload, 'Id', 'WorkflowActionId')} />
                                            { componentErrorMessages.WorkflowActionId && <FormText color="danger"> {componentErrorMessages.WorkflowActionId }</FormText> }
                                        </FormGroup>
                                    </ModalBody>
                                    <ModalFooter>
                                        <Button className="btn-avi-primary" disabled={ requesting } > Proceed </Button>{' '}
                                        <Button color="secondary" onClick={() => this.toggle('workflowUserModal')}>Cancel</Button>
                                    </ModalFooter>
                                </Form>
                                { requesting &&  <div className={'loading-dot active'}></div>}
                            </Modal>
                            <Modal isOpen={this.state.workflowDeleteModal} toggle={() => this.toggle('workflowDeleteModal')} className={this.state.modalClass}>
                                <ModalHeader toggle={() => this.toggle('workflowDeleteModal')}>Remove User</ModalHeader>
                                <ModalBody>
                                    <div className="text-center">
                                        <CheckIcon size="50"/>
                                    </div>
                                    { modalResponse }
                                    <h5 className='text-center mb-3 mt-2'>
                                        Are you sure you want to remove <span className={'text-capitalize'}>{WorkflowActionUser.LastName} {WorkflowActionUser.FirstName} ?</span>
                                    </h5>
                                </ModalBody>
                                <ModalFooter>
                                    <Button className="btn-avi-primary" disabled={ requesting } onClick={this.removeUser} > Confirm </Button>{' '}
                                    <Button color="secondary" onClick={() => this.toggle('workflowDeleteModal')}>Cancel</Button>
                                </ModalFooter>
                                { requesting &&  <div className={'loading-dot active'}></div>}
                            </Modal>
                        </CardBody>
                        }
                        <NotificationSystem ref="notificationSystem"/>
                    </Card>
                </ViewContent>
            </div>
        );
    }
}
function mapStateToProps(state, ownProps) {
    const { loggingIn } = state.authentication;
    const { requesting, pageRequesting } = state.api;
    const { alert, modal, users } = state;
    return {
        loggingIn,
        requesting,
        pageRequesting,
        modal,
        alert,
        users,
    };
}
export default connect(mapStateToProps)(WorkflowUserViewContent);



// WEBPACK FOOTER //
// ./src/views/workflow/view-user-content.js